import { useStyletron } from "baseui";
import { AppNavBar } from "baseui/app-nav-bar";
import { Avatar } from "baseui/avatar";
import { Block } from "baseui/block";
import { Tab, Tabs } from "baseui/tabs-motion";
import { IoAddCircle, IoCompass, IoMegaphone, IoNotifications } from "react-icons/io5";
import { HiGlobe } from "react-icons/hi";
import { useDispatch, useSelector } from 'react-redux';
import { setActiveTab } from "../application/actions/ui";
import { getActiveTab } from "../application/selectors/ui";
import useBreakpoint from "../hooks/useBreakpoint";
import useWhoAmI from "../hooks/useWhoAmI";
import useLocale from "../hooks/useLocale";
import ReDoNotificationsHover from "./ReDoNotificationsHover";


const ReDoNavBar = () => {
  const dispatch = useDispatch();
  const breakpoint = useBreakpoint()
  const activeTab = useSelector(getActiveTab);
  const [css, theme] = useStyletron();

  const { userProfile, isAdmin } = useWhoAmI();
  const { t, language, changeLanguage } = useLocale();

  const iconSize = breakpoint === 'xsmall' || breakpoint === 'small' ? 28 : 36;
  const avatarSize = breakpoint === 'xsmall' || breakpoint === 'small' ? '28px' : '36px';
  const tabs = [
    { label: t('nav.explore'), title: <IoCompass size={iconSize} />, id: '0' },
    { label: t('nav.create'), title: <IoAddCircle size={iconSize} />, id: '1' },
    { label: t('nav.notifications'), title: <IoNotifications size={iconSize} />, id: '2' },
    {
      label: t('nav.profile'),
      title: <Avatar
        name={userProfile.fullname}
        size={avatarSize}
        src={userProfile.photo}
      />,
      id: '3'
    },
    // admin-only broadcast composer tab
    ...(isAdmin ? [{ label: 'Admin', title: <IoMegaphone size={iconSize} />, id: '4' }] : []),
  ].map(i => ({ ...i, active: activeTab === i.id }))

  const onTabChange = ({ activeKey }) => {
    /*if (activeKey === '1') {
      dispatch(routeTo({ view: 'createSolution' }))
    } else {*/
    dispatch(setActiveTab(activeKey))
    //}
  }

  const onMainItemSelect = item => {
    /*if (item.id === '1') {
      dispatch(routeTo({ view: 'createSolution' }))
    } else {*/
    dispatch(setActiveTab(item.id))
    //}
  }

  return (
    <>
      {breakpoint === 'large' &&
        <Block display='flex' justifyContent='space-between' alignItems='center'>
          <AppNavBar
            mapItemToNode={(item) => {
              if (item.id === '2') {
                return <ReDoNotificationsHover item={item} />
              } else {
                return item.label
              }
            }}
            overrides={{
              Root: {
                style: {
                  border: '0',
                  backgroundColor: 'transparent',
                  padding: '0 !important'
                }
              },
              MainMenuItem: {
                style: (item) => {
                  return {
                    ...item.style,
                    borderBottom: 'none',
                    fontWeight: item.$active ? 'bold' : 'normal',
                  }
                }
              },
              PrimaryMenuContainer: {
                style: {
                  gap: '4ch',
                  alignItems: 'center',
                }
              },
            }}
            mainItems={tabs}
            onMainItemSelect={onMainItemSelect}
          />
          <button
            onClick={() => changeLanguage(language.startsWith('de') ? 'en' : 'de')}
            className={css({
              background: 'none',
              border: 'none',
              cursor: 'pointer',
              padding: '8px 12px',
              display: 'flex',
              alignItems: 'center',
              gap: '6px',
              color: theme.colors.primary400,
              borderRadius: '24px',
              transition: 'all 0.2s ease-in-out',
              ':hover': {
                backgroundColor: theme.colors.primary100,
              }
            })}
            title={language.startsWith('de') ? 'Switch to English' : 'Auf Deutsch wechseln'}
          >
            <HiGlobe size={22} />
            <span style={{ fontWeight: '600', fontSize: '13px', letterSpacing: '0.03em' }}>
              {language.startsWith('de') ? 'DE' : 'EN'}
            </span>
          </button>
        </Block>
      }

      {(breakpoint === 'small' || breakpoint === 'medium' || breakpoint === 'xsmall') &&
        <div className="nav-bar">
          <Tabs
            activeKey={activeTab.split('/')[0]}
            onChange={onTabChange}
            activateOnFocus
            overrides={{
              Root: {
                style: ({ $theme }) => ({
                  position: 'fixed',
                  bottom: 0,
                  width: '100%',
                  backgroundColor: theme.colors.primary100,
                  left: 0,
                })
              },
              TabBorder: {
                style: ({ $theme }) => ({
                  backgroundColor: 'transparent'
                })
              },
              TabHighlight: {
                style: () => ({
                  display: 'none'
                })
              },
              TabList: {
                style: () => ({
                  justifyContent: 'space-evenly',
                  paddingBottom: '0',
                })
              },
            }}
          >
            {tabs.map((tab) => (
              <Tab
                key={tab.id}
                overrides={{
                  Tab: {
                    style: () => ({
                      background: 'transparent',
                      ':hover': {
                        background: 'transparent',
                      },
                      opacity: activeTab === tab.id ? '1' : '0.3',
                      transition: 'all 0.2s ease-in-out',
                    })
                  }
                }} title={tab.title}></Tab>
            ))}
          </Tabs>
        </div>
      }
    </>
  );
}

export default ReDoNavBar